import { NgModule } from '@angular/core'
import { ButtonBasicDirective } from './button-basic.directive'

@NgModule({
    declarations: [ButtonBasicDirective],
    exports: [ButtonBasicDirective]
})
export class ButtonBasicModule {}
